// import * as firebase from 'firebase/app';
// import 'firebase/storage';
import API from '@/api';
import V3API from '@/api/v3';
import hasPermission from '../../utils/hasPermission';
import { groupPermissions } from '../../utils/licenseDetails';

const SET_FROM_DATE = 'SET_FROM_DATE';
const SET_TO_DATE = 'SET_TO_DATE';

const GET_LICENSES = 'GET_LICENSES';
const GET_LICENSES_SUCCESS = 'GET_LICENSES_SUCCESS';
const GET_LICENSES_FAILED = 'GET_LICENSES_FAILED';
const RESET_LICENSES = 'RESET_LICENSES';

const GET_USER_LICENSES = 'GET_USER_LICENSES';
const GET_USER_LICENSES_SUCCESS = 'GET_USER_LICENSES_SUCCESS';
const GET_USER_LICENSES_FAILED = 'GET_USER_LICENSES_FAILED';
const RESET_USER_LICENSES = 'RESET_USER_LICENSES';

const DEACTIVATE_LICENSE_PRODUCT = 'DEACTIVATE_LICENSE_PRODUCT';
const DEACTIVATE_LICENSE_PRODUCT_SUCCESS = 'DEACTIVATE_LICENSE_PRODUCT_SUCCESS';
const DEACTIVATE_LICENSE_PRODUCT_FAILED = 'DEACTIVATE_LICENSE_PRODUCT_FAILED';

const GET_ADMIN_METRICS = 'GET_ADMIN_METRICS';
const GET_ADMIN_METRICS_FAILED = 'GET_ADMIN_METRICS_FAILED';
const GET_ADMIN_METRICS_SUCCESS = 'GET_ADMIN_METRICS_SUCCESS';

const GET_ACTIVE_USERS = 'GET_ACTIVE_USERS';
const GET_ACTIVE_USERS_SUCCESS = 'GET_ACTIVE_USERS_SUCCESS';
const GET_ACTIVE_USERS_FAILED = 'GET_ACTIVE_USERS_FAILED';

const GET_POPULAR_COURSES = 'GET_POPULAR_COURSES';
const GET_POPULAR_COURSES_SUCCESS = 'GET_POPULAR_COURSES_SUCCESS';
const GET_POPULAR_COURSES_FAILED = 'GET_POPULAR_COURSES_FAILED';

const GET_ROUNDS_PER_LICENSE = 'GET_ROUNDS_PER_LICENSE';
const GET_ROUNDS_PER_LICENSE_SUCCESS = 'GET_ROUNDS_PER_LICENSE_SUCCESS';
const GET_ROUNDS_PER_LICENSE_FAILED = 'GET_ROUNDS_PER_LICENSE_FAILED';

const GET_SHOTS_ROUNDS = 'GET_SHOTS_ROUNDS';
const GET_SHOTS_ROUNDS_SUCCESS = 'GET_SHOTS_ROUNDS_SUCCESS';
const GET_SHOTS_ROUNDS_FAILED = 'GET_SHOTS_ROUNDS_FAILED';

const GET_CLUB_SHOTS = 'GET_CLUB_SHOTS';
const GET_CLUB_SHOTS_SUCCESS = 'GET_CLUB_SHOTS_SUCCESS';
const GET_CLUB_SHOTS_FAILED = 'GET_CLUB_SHOTS_FAILED';

const GET_TS_SHOTS = 'GET_TS_SHOTS';
const GET_TS_SHOTS_SUCCESS = 'GET_TS_SHOTS_SUCCESS';
const GET_TS_SHOTS_FAILED = 'GET_TS_SHOTS_FAILED';

const GET_PRACTICE_AREA_SHOTS = 'GET_PRACTICE_AREA_SHOTS';
const GET_PRACTICE_AREA_SHOTS_SUCCESS = 'GET_PRACTICE_AREA_SHOTS_SUCCESS';
const GET_PRACTICE_AREA_SHOTS_FAILED = 'GET_PRACTICE_AREA_SHOTS_FAILED';

const GET_GAME_MODE_METRICS = 'GET_GAME_MODE_METRICS';
const GET_GAME_MODE_METRICS_SUCCESS = 'GET_GAME_MODE_METRICS_SUCCESS';
const GET_GAME_MODE_METRICS_FAILED = 'GET_GAME_MODE_METRICS_FAILED';

const GET_SALES_LOG = 'GET_SALES_LOG';
const GET_DAILY_SALES_LOG_SUCCESS = 'GET_DAILY_SALES_LOG_SUCCESS';
const GET_DAILY_SALES_LOG_FAILED = 'GET_DAILY_SALES_LOG_FAILED';
const GET_SALES_LOG_SUCCESS = 'GET_SALES_LOG_SUCCESS';
const GET_SALES_LOG_FAILED = 'GET_SALES_LOG_FAILED';
const RESET_DAILY_SALES_LOG = 'RESET_DAILY_SALES_LOG';

const REDEEM_PRODUCT = 'REDEEM_PRODUCT';
const REDEEM_PRODUCT_FAILED = 'REDEEM_PRODUCT_FAILED';
const REDEEM_PRODUCT_SUCCESS = 'REDEEM_PRODUCT_SUCCESS';

const LICENSE_ACTIVATION = 'LICENSE_ACTIVATION';
const LICENSE_ACTIVATION_FAILED = 'LICENSE_ACTIVATION_FAILED';
const LICENSE_ACTIVATION_SUCCESS = 'LICENSE_ACTIVATION_SUCCESS';

const GET_TRACKING_SYSTEMS = 'GET_TRACKING_SYSTEMS';
const GET_TRACKING_SYSTEMS_SUCCESS = 'GET_TRACKING_SYSTEMS_SUCCESS';
const GET_TRACKING_SYSTEMS_FAILED = 'GET_TRACKING_SYSTEMS_FAILED';

const GET_PRODUCT_KEYS = 'GET_PRODUCT_KEYS';
const GET_PRODUCT_KEYS_SUCCESS = 'GET_PRODUCT_KEYS_SUCCESS';
const GET_PRODUCT_KEYS_FAILED = 'GET_PRODUCT_KEYS_FAILED';
const CREATE_PRODUCT_KEYS = 'CREATE_PRODUCT_KEYS';
const CREATE_PRODUCT_KEYS_SUCCESS = 'CREATE_PRODUCT_KEYS_SUCCESS';
const CREATE_PRODUCT_KEYS_FAILED = 'CREATE_PRODUCT_KEYS_FAILED';

const GET_PRODUCTS = 'GET_PRODUCTS';
const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';

const GET_PRODUCT = 'GET_PRODUCT';
const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
const GET_PRODUCT_FAILED = 'GET_PRODUCT_FAILED';

const GET_TRANSACTIONS = 'GET_TRANSACTIONS';
const GET_TRANSACTIONS_SUCCESS = 'GET_TRANSACTIONS_SUCCESS';
const GET_TRANSACTIONS_FAILED = 'GET_TRANSACTIONS_FAILED';

// @ Marketing Report Data ==================
const GET_REPORT = 'GET_REPORT';
const GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS';
const GET_REPORT_FAILED = 'GET_REPORT_FAILED';
const GET_REPORT_FILTER = 'GET_REPORT_FILTER';
const GET_REPORT_FILTER_SUCCESS = 'GET_REPORT_FILTER_SUCCESS';
const GET_REPORT_FILTER_FAILED = 'GET_REPORT_FILTER_FAILED';
const SET_REPORT_FILTER = 'SET_REPORT_FILTER';
const SET_REPORT_FILTER_SUCCESS = 'SET_REPORT_FILTER_SUCCESS';
const SET_REPORT_FILTER_FAILED = 'SET_REPORT_FILTER_FAILED';
const GET_LICENSE_REDEEM = 'GET_LICENSE_REDEEM';
const GET_LICENSE_REDEEM_SUCCESS = 'GET_LICENSE_REDEEM_SUCCESS';
const GET_LICENSE_REDEEM_FAILED = 'GET_LICENSE_REDEEM_FAILED';
const GET_EXPIRING_SUB = 'GET_EXPIRING_SUB';
const GET_EXPIRING_SUB_SUCCESS = 'GET_EXPIRING_SUB_SUCCESS';
const GET_EXPIRING_SUB_FAILED = 'GET_EXPIRING_SUB_FAILED';
const RESET_LICENSE_LOG = 'RESET_LICENSE_LOG';

// @ New Admin Data ==================
const GET_ADMIN_DATA = 'GET_ADMIN_DATA';
const GET_ADMIN_DATA_FAILED = 'GET_ADMIN_DATA_FAILED';
const GET_ADMIN_DATA_SUCCESS = 'GET_ADMIN_DATA_SUCCESS';

const GET_ADMIN_GAME_MODES = 'GET_ADMIN_GAME_MODES';
const GET_ADMIN_GAME_MODES_FAILED = 'GET_ADMIN_GAME_MODES_FAILED';
const GET_ADMIN_GAME_MODES_SUCCESS = 'GET_ADMIN_GAME_MODES_SUCCESS';

const GET_ADMIN_SIMULATOR_PERMISSIONS = 'GET_ADMIN_SIMULATOR_PERMISSIONS';
const GET_ADMIN_SIMULATOR_PERMISSIONS_FAILED = 'GET_ADMIN_SIMULATOR_PERMISSIONS_FAILED';
const GET_ADMIN_SIMULATOR_PERMISSIONS_SUCCESS = 'GET_ADMIN_SIMULATOR_PERMISSIONS_SUCCESS';

const GET_ADMIN_TRACKING_SYSTEMS = 'GET_ADMIN_TRACKING_SYSTEMS';
const GET_ADMIN_TRACKING_SYSTEMS_FAILED = 'GET_ADMIN_TRACKING_SYSTEMS_FAILED';
const GET_ADMIN_TRACKING_SYSTEMS_SUCCESS = 'GET_ADMIN_TRACKING_SYSTEMS_SUCCESS';

const COURSE_SYNC = 'COURSE_SYNC';
const COURSE_SYNC_FAILED = 'COURSE_SYNC_FAILED';
const COURSE_SYNC_SUCCESS = 'COURSE_SYNC_SUCCESS';

// Enabled the module to be namespaced
const namespaced = true;

function toCSV(json = {}, keys = []) {
  json = Object.values(json);
  let csv = '';
  csv += `${keys.join(',')}\n`;
  for (const line of json) {
    csv += `${keys
      .map((key) => {
        return Array.isArray(line[key]) ? line[key].join(` / `) : line[key];
        // return line[key];
      })
      .join(',')}\n`;
  }
  return csv;
}

function convertToCSV(arr) {
  const array = [Object.keys(arr[0])].concat(arr);
  return array
    .map((row) => {
      return Object.values(row)
        .map((value) => {
          return typeof value === 'string' ? JSON.stringify(value) : value;
        })
        .toString();
    })
    .join('\n');
}

function formatData(data) {
  if (!data) {
    return [];
  }
  let keyData = [];
  const partnerDataKeys = Object.keys(data);
  partnerDataKeys.forEach((partner) => {
    keyData = [...keyData, ...data[partner]];
  });
  return keyData;
}

const state = {
  fromDate: null,
  toDate: null,
  loading: false,
  loadingAdminMetrics: false,
  adminMetrics: {},
  loadingLicenses: false,
  licenses: [],
  totalUsers: null,
  totalActiveUsers: null,
  loadingActiveUsers: false,
  limitedUsers: null,
  loadingLimitedUsers: false,
  activeApexUsers: null,
  loadingActiveApexUsers: false,
  activeConnectUsers: null,
  loadingActiveConnectUsers: false,
  popularCourses: [],
  loadingPopularCourses: false,
  roundsPerLicense: [],
  loadingRoundsPerLicense: false,
  shotDataMetrics: {},
  totalNumberOfShots: null,
  loadingTotalShots: false,
  totalNumberOfRounds: null,
  loadingTotalRounds: false,
  shotsByUsers: null,
  loadingUserShots: false,
  shotsByGuests: null,
  loadingGuestShots: false,
  loadingShotsRounds: false,
  clubShots: [],
  loadingClubShots: false,
  trackingSystemShots: [],
  loadingTrackingSystemShots: false,
  practiceAreaShots: [],
  loadingPracticeAreaShots: false,
  gameModeMetrics: [],
  loadingGameModeMetrics: false,
  loadingUserLicenses: false,
  userLicenses: [],
  loadingSalesLog: false,
  salesLog: [],
  dailySalesLog: null,
  loadingRedeemProduct: false,
  redeemedProduct: {},
  loadingDeactivate: false,
  loadingLicenseActivation: false,
  loadingTrackingSystems: false,
  trackingSystems: [],

  productKeys: [],
  newProductKeys: [],
  loadingProductKeys: false,
  products: [],
  loadingProducts: false,
  product: {},
  loadingProduct: false,
  loadingTransactions: false,

  // @ Marketing Report Data ==================
  loadingReport: false,
  loadingReportFilter: false,
  loadingLicenseRedeem: false,
  loadingExpiringSub: false,

  storeReport: [],
  licenseReport: {},
  expSubReport: {},
  reportFilter: null,
  redeemedLicenses: [],
  expiringSubscriptions: [],

  // @ New Admin ====================
  loadingAdmin: false,
  loadingAdminGameModes: false,
  loadingAdminSimulatorPermissions: false,
  loadingAdminTrackingSystems: false,

  loadingCourseSync: false,
};

const getters = {
  // @ GENERAL ==================
  getFromDate: (state) => {
    return state.fromDate;
  },
  getToDate: (state) => {
    return state.toDate;
  },

  // @ METRICS ==================
  //* returns total users
  totalUsers: (state) => {
    return state.totalUsers;
  },
  //* returns active users
  getActiveUsers: (state) => {
    return state.totalActiveUsers;
  },
  //* returns active apex users
  getActiveApexUsers: (state) => {
    return state.activeApexUsers;
  },
  //* returns active connect users
  getActiveConnectUsers: (state) => {
    return state.activeConnectUsers;
  },
  //* returns limited user total
  getLimitedUsers: (state) => {
    return state.limitedUsers;
  },

  //* returns popular courses
  popularCourses: (state) => {
    return state.popularCourses;
  },
  //* returns total rounds per license
  roundsPerLicense: (state) => {
    return (
      state.roundsPerLicense?.sort((a, b) => {
        return b.shots - a.shots;
      }) ?? []
    );
  },
  //* returns all licenses data
  getLicenses: (state) => {
    return state.licenses;
  },
  //* returns shots and rounds data
  getShotDataMetrics: (state) => {
    return state.shotDataMetrics;
  },
  totalNumberOfShots: (state) => {
    return state.totalNumberOfShots;
  },
  totalNumberOfRounds: (state) => {
    return state.totalNumberOfRounds;
  },
  shotsByUsers: (state) => {
    return state.shotsByUsers;
  },
  shotsByGuests: (state) => {
    return state.shotsByGuests;
  },
  //* returns number of shots per club
  getClubShots: (state) => {
    return state.clubShots;
  },
  //* returns number of shots per tracking system
  getTrackingSystemShots: (state) => {
    return state.trackingSystemShots;
  },
  //* returns number of shots per practice area
  getPracticeAreaShots: (state) => {
    return state.practiceAreaShots;
  },
  //* returns game mode metrics
  getGameModeMetrics: (state) => {
    return state.gameModeMetrics;
  },

  // @ Accounting Data ==================
  //* returns daily sales log
  getDailySalesLog: (state) => {
    return state.dailySalesLog;
  },
  //* returns daily sales log
  getSalesLog: (state) => {
    return state.salesLog;
  },

  //* returns tracking systems
  getTrackingSystems: (state) => {
    if (!Array.isArray(state.trackingSystems)) {
      return [];
    }
    return [...state.trackingSystems].sort((a, b) => {
      if (a.name.toLowerCase().includes('tru')) return -1;
      if (b.name.toLowerCase().includes('tru')) return 1;
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });
  },

  // @ Product/shop Data ==================
  //* returns product keys
  getProductKeys: (state) => {
    return state.productKeys;
  },

  //* returns products
  getProducts: (state) => {
    return state.products;
  },

  //* returns individual product
  getProduct: (state) => {
    return state.product;
  },

  // @ Marketing Report Data ==================
  //* returns report
  getStoreReport: (state) => {
    return state.storeReport;
  },
  getLicenseReport: (state) => {
    return state.licenseReport;
  },
  getExpSubReport: (state) => {
    return state.expSubReport;
  },
  //* returns report filter
  getReportFilter: (state) => {
    return state.reportFilter;
  },
  //* returns redeemed licenses
  getRedeemedLicenses: (state) => {
    return state.redeemedLicenses;
  },
  //* returns expiring subscriptions
  getExpiringSubscriptions: (state) => {
    return state.expiringSubscriptions;
  },

  // @ LICENSE DATA ==================
  //* returns user licenses
  getUserLicenses: (state) => {
    return state.userLicenses;
  },

  // @ LOADING INDICATORS ==================
  loading: (state) => {
    return state.loading;
  },
  isLoadingActiveUsers: (state) => {
    return state.loadingActiveUsers;
  },
  isLoadingActiveApexUsers: (state) => {
    return state.loadingActiveApexUsers;
  },
  isLoadingActiveConnectUsers: (state) => {
    return state.loadingActiveConnectUsers;
  },
  isLoadingLimitedUsers: (state) => {
    return state.loadingLimitedUsers;
  },
  isLoadingCourses: (state) => {
    return state.loadingPopularCourses;
  },
  isLoadingRounds: (state) => {
    return state.loadingRoundsPerLicense;
  },
  isLoadingLicenses: (state) => {
    return state.loadingLicenses;
  },
  isLoadingShotsRounds: (state) => {
    return state.loadingShotsRounds;
  },
  isLoadingTotalShots: (state) => {
    return state.loadingTotalShots;
  },
  isLoadingTotalRounds: (state) => {
    return state.loadingTotalRounds;
  },
  isLoadingUserShots: (state) => {
    return state.loadingUserShots;
  },
  isLoadingGuestShots: (state) => {
    return state.loadingGuestShots;
  },
  isLoadingClubShots: (state) => {
    return state.loadingClubShots;
  },
  isLoadingPracticeAreaShots: (state) => {
    return state.loadingPracticeAreaShots;
  },
  isLoadingGameModeMetrics: (state) => {
    return state.loadingGameModeMetrics;
  },
  isLoadingTrackingSystems: (state) => {
    return state.loadingTrackingSystems;
  },
  isLoadingTrackingSystemShots: (state) => {
    return state.loadingTrackingSystemShots;
  },
  isLoadingUserLicenses: (state) => {
    return state.loadingUserLicenses;
  },
  isLoadingSalesLog: (state) => {
    return state.loadingSalesLog;
  },
  isLoadingRedeemProduct: (state) => {
    return state.loadingRedeemProduct;
  },
  isLoadingLicenseActivation: (state) => {
    return state.loadingLicenseActivation;
  },
  isLoadingProductKeys: (state) => {
    return state.loadingProductKeys;
  },
  isLoadingProducts: (state) => {
    return state.loadingProducts;
  },
  isLoadingProduct: (state) => {
    return state.loadingProduct;
  },
  isLoadingTransactions: (state) => {
    return state.loadingTransactions;
  },
  isLoadingReport: (state) => {
    return state.loadingReport;
  },
  isLoadingReportFilter: (state) => {
    return state.loadingReportFilter;
  },
  isLoadingLicenseRedeem: (state) => {
    return state.loadingLicenseRedeem;
  },
  isLoadingExpiringSub: (state) => {
    return state.loadingExpiringSub;
  },

  //* New Admin
  isLoadingAdmin: (state) => {
    return state.loadingAdmin;
  },
  isLoadingAdminGameModes: (state) => {
    return state.loadingAdminGameModes;
  },
  isLoadingAdminSimulatorPermissions: (state) => {
    return state.loadingAdminSimulatorPermissions;
  },
  isLoadingAdminTrackingSystems: (state) => {
    return state.loadingAdminTrackingSystems;
  },

  //* Updated Metrics
  isLoadingAdminMetrics: (state) => {
    return state.loadingAdminMetrics;
  },
  //* returns admin metrics
  getAdminMetrics: (state) => {
    return state.adminMetrics;
  },

  isLoadingCourseSync: (state) => {
    return state.loadingCourseSync;
  },
};

const actions = {
  //* activeUsers gets the total and active users stats by date range
  async activeUsers({ commit }, payload) {
    let response = {};

    commit(GET_ACTIVE_USERS, payload);

    try {
      response = await API.admin.activeUsers(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ACTIVE_USERS_FAILED);
        reject(response);
      } else {
        response.data = { ...response.data, ...payload };
        commit(GET_ACTIVE_USERS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getShotsRounds gets all of the shot/round total data by date range
  async getShotsRounds({ commit }, payload) {
    let response = {};

    commit(GET_SHOTS_ROUNDS, payload);

    try {
      response = await API.admin.shotsAndRounds(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SHOTS_ROUNDS_FAILED);
        reject(response);
      } else {
        response.data = { ...response.data, ...payload };
        commit(GET_SHOTS_ROUNDS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getPopularCourses gets the most popular courses by date range
  async getPopularCourses({ commit }, payload) {
    let response = {};

    commit(GET_POPULAR_COURSES);

    try {
      response = await API.admin.popularCourses(payload);

      if (!response?.data) {
        response.data = [];
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_POPULAR_COURSES_FAILED);
        reject(response);
      } else {
        commit(GET_POPULAR_COURSES_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getRoundsPerLicense gets the most popular courses by date range
  async getRoundsPerLicense({ commit }, payload) {
    let response = {};

    commit(GET_ROUNDS_PER_LICENSE);

    try {
      response = await API.admin.roundsPerLicense(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ROUNDS_PER_LICENSE_FAILED);
        reject(response);
      } else {
        commit(GET_ROUNDS_PER_LICENSE_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getLicenses gets all of the license data by date range - used for admin license query
  async getLicenses({ commit }, payload) {
    let response = {};

    commit(GET_LICENSES);

    try {
      response = await API.admin.licenses(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_LICENSES_FAILED);
        reject(response);
      } else {
        commit(GET_LICENSES_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getClubTypeShots gets all of the shots per club data by date range
  async getClubTypeShots({ commit }, payload) {
    let response = {};

    commit(GET_CLUB_SHOTS);

    try {
      response = await API.admin.clubTypeShots(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_CLUB_SHOTS_FAILED);
        reject(response);
      } else {
        commit(GET_CLUB_SHOTS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getTrackingSystemShots gets all of the shots per tracking system by date range
  async getTrackingSystemShots({ commit }, payload) {
    let response = {};

    commit(GET_TS_SHOTS);

    try {
      response = await API.admin.trackingSystemShots(payload);
      if (!response?.data && response?.status === 200) {
        response.data = [];
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_TS_SHOTS_FAILED);
        reject(response);
      } else {
        commit(GET_TS_SHOTS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getPracticeAreaShots gets all of the shots per practice area by date range
  async getPracticeAreaShots({ commit }, payload) {
    let response = {};

    commit(GET_PRACTICE_AREA_SHOTS);

    try {
      response = await API.admin.practiceAreaShots(payload);

      if (!response?.data?.length) {
        response.data = [];
      }

      response.data = response?.data?.sort((a, b) => {
        if (a?.count < b?.count) return 1;
        if (a?.count > b?.count) return -1;
        return 0;
      });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRACTICE_AREA_SHOTS_FAILED);
        reject(response);
      } else {
        commit(GET_PRACTICE_AREA_SHOTS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* getGameModeMetrics gets game mode metrics by date range
  async getGameModeMetrics({ commit }, payload) {
    let response = {};

    commit(GET_GAME_MODE_METRICS);

    try {
      response = await API.admin.gameModeMetrics(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_GAME_MODE_METRICS_FAILED);
        reject(response);
      } else {
        commit(GET_GAME_MODE_METRICS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* adminMetrics gets the metrics
  // async adminMetrics({ commit }, payload) {
  //   console.log('payload adminMetrics store:', payload);
  //   let response = {};

  //   commit(GET_ADMIN_METRICS, payload);

  //   try {
  //     response = await API.admin.adminMetrics(payload);
  //   } catch (error) {
  //     response = error;
  //   }

  //   return new Promise((resolve, reject) => {
  //     if (response.status >= 400) {
  //       commit(GET_ADMIN_METRICS_FAILED);
  //       reject(response);
  //     } else {
  //       response.data = { ...response.data, ...payload };
  //       commit(GET_ADMIN_METRICS_SUCCESS, response.data);
  //       resolve(response.data);
  //     }
  //   });
  // },

  //* getUserLicenses returns a list of a user's licenses
  async getUserLicenses({ commit }, payload) {
    let response = {};
    const { isUUID, isFullEmail } = payload;

    commit(GET_USER_LICENSES);

    try {
      if (isUUID || isFullEmail) {
        response = await API.admin.userLicenses(payload);
      } else {
        response = await API.admin.userLicensesPartial(payload);
      }

      if (response?.data?.length) {
        response.data = await Promise.all(
          response?.data?.map(async (license) => {
            try {
              //* Parallel API calls for better performance
              const [licenseDetailsResponse, apexLicenseResponse] = await Promise.all([
                license.licenseType === 'desktop'
                  ? API.licenses.show(license.licenseID)
                  : license.licenseType === 'mobile'
                  ? API.licenses.showMobile(license.licenseID)
                  : Promise.resolve({ data: null }),
                V3API.licenses.licenseGet({ id: license.licenseID }),
              ]);

              //* Check for multi-sport
              const { license_key: licenseKey } = licenseDetailsResponse?.data ?? {};
              if (licenseKey?.startsWith('multi')) {
                licenseDetailsResponse.data.type = 'multi-sport';
              } else {
                licenseDetailsResponse.data.type = license?.licenseType ?? 'desktop';
              }

              //* Group permissions
              if (!licenseDetailsResponse.data) return {};
              if (!licenseDetailsResponse?.data?.permissions) {
                licenseDetailsResponse.data.permissions = [];
              }

              const grouped = groupPermissions(licenseDetailsResponse?.data);

              const processedLicenseData = {
                license: {
                  ...licenseDetailsResponse?.data,
                  name: apexLicenseResponse?.data?.name || licenseDetailsResponse?.data?.name,
                },
                type: licenseDetailsResponse?.data?.type,
                courses: grouped.courses ?? [],
                apexCourses: grouped.apexCourses ?? [],
                connectCourses: grouped.connectCourses ?? [],
                trackingSystems: grouped.trackingSystems ?? [],
                permissions: grouped.permissions ?? [],
                // apexBinding: apexLicenseResponse?.data?.apex_binding,
                apexDeviceName: apexLicenseResponse?.data?.apex_binding?.client_name,
                ...(apexLicenseResponse?.data?.apex_binding && {
                  apexBinding: apexLicenseResponse?.data?.apex_binding,
                }),
              };

              return {
                ...license,
                ...processedLicenseData,
                licenseName: processedLicenseData?.license?.name,
              };
            } catch (error) {
              console.error(`Error processing license ${license.licenseID}:`, error);
              //* Return the original license data with error flag
              return {
                ...license,
                error: true,
                errorMessage: 'Failed to load license details',
              };
            }
          })
        );
      }
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_USER_LICENSES_FAILED);
        reject(response);
      } else {
        commit(GET_USER_LICENSES_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Create new license for user
  async createLicense({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.createLicense(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * deactivateLicenseProduct deactivates a product from a user's licenses
  async deactivateLicenseProduct({ commit }, payload) {
    let response = {};

    commit(DEACTIVATE_LICENSE_PRODUCT);

    try {
      response = await API.admin.deactivateLicenseProduct(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(DEACTIVATE_LICENSE_PRODUCT_FAILED);
        reject(response);
      } else {
        commit(DEACTIVATE_LICENSE_PRODUCT_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  resetUserLicenses({ commit }) {
    commit(RESET_USER_LICENSES);
  },

  //* getDailySalesLog gets the daily sales log
  async getDailySalesLog({ commit }, payload) {
    let response = {};

    commit(GET_SALES_LOG);

    try {
      response = await API.admin.dailySalesLog(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_DAILY_SALES_LOG_FAILED);
        reject(response);
      } else {
        commit(GET_DAILY_SALES_LOG_SUCCESS, response.data ?? []);
        resolve(response.data);
      }
    });
  },

  //* getSalesLog gets the sales log by date range
  async getSalesLog({ commit }, payload) {
    let response = {};

    commit(GET_SALES_LOG);

    try {
      response = await API.admin.salesLogExport(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_SALES_LOG_FAILED);
        reject(response);
      } else {
        commit(GET_SALES_LOG_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* redeemProduct redeems a product to a user's license
  async redeemProduct({ commit }, payload) {
    let response = {};

    commit(REDEEM_PRODUCT);

    try {
      response = await API.admin.redeemProduct(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(REDEEM_PRODUCT_FAILED);
        reject(response);
      } else {
        commit(REDEEM_PRODUCT_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },
  //* deactivateLicense deactivates a user's license
  async deactivateLicense({ commit }, payload) {
    let response = {};

    commit(LICENSE_ACTIVATION);

    try {
      response = await API.admin.deactivateLicense(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(LICENSE_ACTIVATION_FAILED);
        reject(response);
      } else {
        commit(LICENSE_ACTIVATION_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* activateLicense re-activates a user's license
  async activateLicense({ commit }, payload) {
    let response = {};

    commit(LICENSE_ACTIVATION);

    try {
      response = await API.admin.activateLicense(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(LICENSE_ACTIVATION_FAILED);
        reject(response);
      } else {
        commit(LICENSE_ACTIVATION_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* licenseUpdate updates a user's license - used to set or clear expires_at
  async licenseUpdate({ commit }, payload) {
    let response = {};

    commit(LICENSE_ACTIVATION);

    try {
      response = await API.admin.licenseUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(LICENSE_ACTIVATION_FAILED);
        reject(response);
      } else {
        commit(LICENSE_ACTIVATION_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getProductKeys gets a list of all product keys
  // async getProductKeys({ commit }, payload = {}) {
  //   let response = {};

  //   commit(GET_PRODUCT_KEYS);

  //   try {
  //     response = await API.admin.productKeys(payload);
  //   } catch (error) {
  //     response = error;
  //   }

  //   return new Promise((resolve, reject) => {
  //     if (response.status >= 400) {
  //       commit(GET_PRODUCT_KEYS_FAILED);
  //       // reject(response);
  //       resolve(response.data);
  //       return response;
  //     }
  //     commit(GET_PRODUCT_KEYS_SUCCESS, response.data);
  //     resolve(response.data);
  //   });
  // },

  // * getProductKeys gets a list of all product keys matching the params.
  async getProductKeys({ commit }, payload) {
    let response = {};

    commit(GET_PRODUCT_KEYS);

    try {
      response = await API.admin.productKeys(payload);

      if (!response?.data) {
        response.data = {};
      }

      if (Array.isArray(response?.data?.data)) {
        const filteredData = response?.data?.data?.map((data) => {
          const payload = {};
          for (const [key, value] of Object.entries(data)) {
            payload[key] = value;
          }
          return payload;
        });
        const keys = [
          'batchUUID',
          'createdByUserID',
          'partnerID',
          'productKey',
          'skucodes',
          'userID',
          'email',
          'type',
          'desktopLicenseID',
          'mobileLicenseID',
          'createdat',
          'updatedat',
        ];

        const csvData = toCSV(filteredData, keys);
        response.data.csv = csvData ?? '';
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRODUCT_KEYS_FAILED);
        reject(response);
      } else {
        commit(GET_PRODUCT_KEYS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * createProductKeys creates new product keys
  async createProductKeys({ commit }, payload) {
    let response = {};
    const csvTest = '';

    commit(CREATE_PRODUCT_KEYS);

    try {
      response = await API.admin.createProductKeys(payload);

      // if (Array.isArray(response?.data)) {
      //   const filteredData = response?.data?.map((data) => {
      //     const payload = {};
      //     for (const [key, value] of Object.entries(data)) {
      //       if (key !== 'createdat') {
      //         payload[key] = value;
      //       }
      //     }
      //     return payload;
      //   });

      //   const csvData = convertToCSV(filteredData);
      //   response.data.csv = csvData ?? '';
      // }

      if (Array.isArray(response?.data)) {
        const filteredData = response?.data?.map((data) => {
          const payload = {};
          for (const [key, value] of Object.entries(data)) {
            payload[key] = value;
          }
          return payload;
        });
        const hasMultipleSkus = filteredData?.[0]?.skucodes?.length > 1 ?? false;
        const keys = [
          'batchUUID',
          'productKey',
          hasMultipleSkus ? 'skucodes' : 'skucode',
          'type',
          'createdByUserID',
          'createdat',
        ];

        const csvData = toCSV(filteredData, keys);
        response.data.csv = csvData ?? '';
      }
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response?.status >= 400 || !response?.status || response?.status === undefined) {
        commit(CREATE_PRODUCT_KEYS_FAILED);
        reject(response);
      } else {
        commit(CREATE_PRODUCT_KEYS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * productKeyDelete deletes a single game mode
  async productKeyDelete({ commit }, key) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.productKeyDelete(key);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * productKeyStatus sets the status for a single game mode
  // @ payload
  // @  "productKey": "1234-5678-1234-5678",
  // @  "status": "disabled" or "active"
  async productKeyStatus({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.productKeyStatus(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // @ Marketing Report Data ==================
  // * storeReport returns the store report data
  async storeReport({ commit }, payload) {
    let response = {};

    commit(GET_REPORT);

    try {
      response = await API.admin.storeReport(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_REPORT_FAILED);
        reject(response);
      } else {
        commit(GET_REPORT_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * setStoreReportFilter sets the filter list for store reports
  async setStoreReportFilter({ commit }, payload) {
    let response;
    commit(SET_REPORT_FILTER);

    try {
      response = await API.admin.setStoreReportFilter(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(SET_REPORT_FILTER_FAILED);
        reject(response);
      }

      commit(SET_REPORT_FILTER_SUCCESS, response.data);
      resolve(response.data);
    });
  },

  // * storeReportFilter returns the store report filter data
  async storeReportFilter({ commit, dispatch }, licenseID) {
    let response = {};

    commit(GET_REPORT_FILTER);

    try {
      response = await API.admin.storeReportFilter(licenseID);

      if (response.data !== '' || response.data !== undefined) {
        const report = response.data.find((item) => {
          return (licenseID = item.report_id);
        });

        if (report) {
          const values = report?.values?.map((sku) => {
            return sku;
          });

          response.data = await Promise.all(
            values?.map(async (sku) => {
              const prod = await API.admin.showSkuProduct(sku);

              return { ...response.data[0], product: prod.data };
            })
          );
        }
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_REPORT_FILTER_FAILED);
        reject(response);
      } else {
        commit(GET_REPORT_FILTER_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * licenseRedemption returns the report for redeemed licenses
  async licenseRedemption({ commit }, payload) {
    let response = {};

    commit(GET_LICENSE_REDEEM);

    try {
      response = await API.admin.licenseRedemption(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_LICENSE_REDEEM_FAILED);
        reject(response);
      } else {
        commit(GET_LICENSE_REDEEM_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * expiringSubscriptions returns the report for redeemed licenses
  async expiringSubscriptions({ commit }, payload) {
    let response = {};

    commit(GET_EXPIRING_SUB);

    try {
      response = await API.admin.expiringSubscriptions(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_EXPIRING_SUB_FAILED);
        reject(response);
      } else {
        commit(GET_EXPIRING_SUB_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getTransactions gets a list of transactions
  async getTransactions({ commit }, payload) {
    let response = {};

    commit(GET_TRANSACTIONS);

    try {
      response = await API.admin.transactions(payload);

      if (!response?.data) {
        response.data = [];
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_TRANSACTIONS_FAILED);
        reject(response);
      } else {
        commit(GET_TRANSACTIONS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // @ Basic Actions ==================
  setFromDate({ commit }, payload) {
    commit(SET_FROM_DATE, payload);
  },

  setToDate({ commit }, payload) {
    commit(SET_TO_DATE, payload);
  },

  resetLicenses({ commit }) {
    commit(RESET_LICENSES);
  },

  resetDailySalesLog({ commit }) {
    commit(RESET_DAILY_SALES_LOG);
  },

  resetLicenseLog({ commit }) {
    commit(RESET_LICENSE_LOG);
  },

  // * getTrackingSystems gets a list of all tracking systems - not-admin specific
  async getTrackingSystems({ commit }, payload) {
    let response = {};

    commit(GET_TRACKING_SYSTEMS);

    try {
      response = await API.admin.listTrackingSystems(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_TRACKING_SYSTEMS_FAILED);
        reject(response);
      } else {
        commit(GET_TRACKING_SYSTEMS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // @ New Admin Actions ==================
  // * gameModes gets a list of all game modes
  async gameModes({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameModes(payload);

      if (!response?.data) {
        response.data = [];
      }

      response.data = response.data.sort((a, b) => {
        if (a?.name < b?.name) return -1;
        if (a?.name > b?.name) return 1;
        return 0;
      });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * gameMode gets a single game mode
  async gameMode({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameMode(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * gameModeEdit edits a single game mode
  async gameModeEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameModeEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * gameModeDelete deletes a single game mode
  async gameModeDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameModeDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * gameModeCreate creates a single game mode
  async gameModeCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameModeCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * simulatorPermissions gets a list of all simulator permissions
  async simulatorPermissions({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.simulatorPermissions(payload);

      if (!response?.data) {
        response.data = [];
      }

      response.data = response.data.sort((a, b) => {
        if (a?.name < b?.name) return -1;
        if (a?.name > b?.name) return 1;
        return 0;
      });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * simulatorPermission gets a single simulator permission
  async simulatorPermission({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.simulatorPermission(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * simulatorPermissionDelete deletes a single game mode
  async simulatorPermissionDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.simulatorPermissionDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * simulatorPermissionEdit edits a single game mode
  async simulatorPermissionEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.simulatorPermissionEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * simulatorPermissionCreate creates a single game mode
  async simulatorPermissionCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.simulatorPermissionCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * trackingSystems gets a list of all tracking systems
  async trackingSystems({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.trackingSystems(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * trackingSystem gets a single tracking system
  async trackingSystem({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.trackingSystem(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * trackingSystemDelete deletes a single tracking system
  async trackingSystemDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.trackingSystemDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * trackingSystemEdit edits a single tracking system
  async trackingSystemEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.trackingSystemEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * trackingSytemCreate creates a single game mode
  async trackingSytemCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.trackingSystemCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * userPermissions gets a list of all user permissions
  async userPermissions({ commit }) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.permissionsList();

      if (!response?.data) {
        response.data = [];
      }

      // response.data = response.data.sort((a, b) => {
      //   if (a?.name < b?.name) return -1;
      //   if (a?.name > b?.name) return 1;
      //   return 0;
      // });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * bundles gets a list of all product bundles
  async bundles({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.bundles(payload);

      if (!response?.data) {
        response.data = [];
      }

      response.data = response.data.sort((a, b) => {
        if (a?.name < b?.name) return -1;
        if (a?.name > b?.name) return 1;
        return 0;
      });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * bundle gets a single bundle
  async bundle({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.bundle(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * bundleCreate creates a new bundle
  async bundleCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.bundleCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * bundleEdit edits a single bundle
  async bundleEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.bundleEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * bundleDelete deletes a single bundle
  async bundleDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.bundleDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * courses gets a list of all courses
  async courses({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.courses(payload);

      if (!response?.data) {
        response.data = [];
      }

      if (response?.data?.length) {
        response.data = response?.data?.sort((a, b) => {
          if (a?.name < b?.name) return -1;
          if (a?.name > b?.name) return 1;
          return 0;
        });
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * coursesPaginated gets a paginated list of courses
  // * response shape: { data: Course[], total_count: number }
  async coursesPaginated({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.coursesPaginated(payload);

      if (!response?.data) {
        response.data = {};
      }
      if (!Array.isArray(response?.data?.data)) {
        response.data.data = [];
      }
      if (typeof response?.data?.total_count !== 'number') {
        response.data.total_count = 0;
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * course gets a single course details
  async course({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.course(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * editCourse edits a single course details
  async courseEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.editCourse(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * courseProdSync pushes a single apex course and version to production
  async courseProdSync({ commit }, payload) {
    let response = {};

    commit(COURSE_SYNC);

    try {
      response = await API.admin.courseProdSync(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(COURSE_SYNC_FAILED);
        reject(response);
      } else {
        commit(COURSE_SYNC_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * courseProdSyncBulk pushes a single apex course and version to production
  // * this pushes a single course in an array, one at a time.
  async courseProdSyncBulk({ commit }, payload) {
    console.log('courseProdSyncBulk:', payload);
    let response = {};

    commit(COURSE_SYNC);

    try {
      console.log(`Calling course sync API for ${payload.name}`);

      response = await API.admin.courseProdSync(payload);

      // await new Promise((resolve) => {
      //   return setTimeout(resolve, 500);
      // }); // Simulated network delay
    } catch (error) {
      console.error(`Error calling course sync API for ${payload.name}:`, error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(COURSE_SYNC_FAILED);
        reject(response);
      } else {
        commit(COURSE_SYNC_SUCCESS, response.data);
        resolve(response);
      }
    });
  },

  // * courseDelete deletes a single course
  async courseDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.courseDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * course gets a single course details
  async courseVersion({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.courseVersion(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * courseVersionEdit edits a single course details
  async courseVersionEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.courseVersionEdit(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * courseVersionDelete deletes a single course version
  async courseVersionDelete({ commit }, payload) {
    console.log('delete payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.courseVersionDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* PRODUCTS ========================================================================
  // * getProducts gets a list of all products
  async getProducts({ commit }, payload = {}) {
    let response = {};

    commit(GET_PRODUCTS);

    try {
      response = await API.admin.products(payload);

      if (!response?.data) {
        response.data = [];
      }

      if (Array.isArray(response.data)) {
        response.data = response.data?.sort((a, b) => {
          if (a?.skucode < b?.skucode) return -1;
          if (a?.skucode > b?.skucode) return 1;
          return 0;
        });
      }
    } catch (error) {
      response = { ...response, error };
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRODUCTS_FAILED);
        reject(response);
      } else {
        commit(GET_PRODUCTS_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getProduct gets a single product - old
  async getProduct({ commit }, payload) {
    let response = {};

    commit(GET_PRODUCT);

    try {
      response = await API.admin.showSkuProduct(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_PRODUCT_FAILED);
        reject(response);
      } else {
        commit(GET_PRODUCT_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * product gets a single product
  async product({ commit }, payload) {
    let response = {};

    // commit(GET_ADMIN_DATA);
    commit(GET_PRODUCT);

    try {
      response = await API.admin.product(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        // commit(GET_ADMIN_DATA_FAILED);
        commit(GET_PRODUCT_FAILED);
        reject(response);
      } else {
        // commit(GET_ADMIN_DATA_SUCCESS, response.data);
        commit(GET_PRODUCT_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * productEdit edits a single product
  async productEdit({ commit }, payload) {
    // console.log('prod store payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.productEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * productCreate creates a new product
  async productCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.productCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * createClubmember creates a new clubmember
  async createClubmember({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.createClubmember(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * userSearch gets a list of users matching query and returns minimal info
  async userSearch({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.userSearch(payload);

      if (!response?.data) {
        response.data = [];
      }

      // response.data = response.data.sort((a, b) => {
      //   if (a?.name < b?.name) return -1;
      //   if (a?.name > b?.name) return 1;
      //   return 0;
      // });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * users returns the list of all users matching the params. User license info returned as well
  async users({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.users(payload);

      if (!response?.data) {
        response.data = {};
      }
      response.data.data = response?.data?.data?.map((user) => {
        const hasLimited = user?.permissions?.includes('LIMITEDUSER');
        return { ...user, limitedUser: hasLimited };
      });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * user returns the user details for a specific user
  async user({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.user(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * userEdit edits a single user details
  async userEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.userEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * ghostUser allows an admin to use the account as any other user
  async ghostUser({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.ghostUser(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        localStorage.setItem('ghostToken', response.data.token);
        resolve(response.data);
      }
    });
  },

  // * activateByID activates the user ID passed in
  async activateByID({ commit }, userID) {
    let response;

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.activateByID(userID);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS);

        resolve(response.data);
      }
    });
  },

  // * getPartners allows an admin to see a list of all partners
  async getPartners({ commit }) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.partners();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * getPartner allows an admin to see a specific partner
  async getPartner({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.partner(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * createPartner allows an admin to create a new partner and return api key to share
  async createPartner({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.createPartner(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * updatePartner allows an admin to update a partner and return api key to share
  async updatePartner({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.updatePartner(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * partnerProductKeyReport allows an admin to get a report for genereated partner product keys
  async partnerProductKeyReport({ commit }, payload) {
    // console.log('payload:', payload);
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.partnerProductKeyReport(payload);

      if (!response?.data) {
        response.data = {};
      }
      response.data = formatData(response.data);

      if (Array.isArray(response?.data)) {
        const filteredData = response?.data?.map((data) => {
          const payload = {};
          for (const [key, value] of Object.entries(data)) {
            payload[key] = value;
          }
          return payload;
        });
        const keys = ['partner_id', 'skucode', 'webtitle', 'total'];

        const csvData = toCSV(filteredData, keys);
        response.data.csv = csvData ?? '';
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Game Versions
  // * getGameVersions allows an admin to see a list of the game versions
  async getGameVersions({ commit }) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameVersions();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * createGameVersion allows an admin to create a new game version
  async createGameVersion({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameVersionCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * updateGameVersion allows an admin to update a game version
  async updateGameVersion({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.gameVersionUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Game Client Downloads - V3
  // * downloadList allows an admin to see a list of all game client download entries
  async downloadList({ commit }) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.downloadList();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * downloadGet allows an admin to view a game client download entry
  async downloadGet({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.downloadGet(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * downloadUpdate allows an admin to update a game client download entry
  async downloadUpdate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.downloadUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * downloadCreate allows an admin to create a game client download entry
  async downloadCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.downloadCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * downloadDelete allows an admin to delete a game client download entry
  async downloadDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.downloadDelete(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * downloadLog posts a record for game client download tracking
  async downloadLog({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.downloadLog(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Customer Feedback - V3 =============================================
  // * gameClientFeedbackList returns a paginated list of game client feedback submissions
  async gameClientFeedbackList({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.gameClientFeedbackList(payload);

      if (!response?.data) {
        response.data = {};
      }
      if (!Array.isArray(response?.data?.game_client_feedbacks)) {
        response.data.game_client_feedbacks = [];
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * gameClientFeedbackUpsertNotes saves the admin notes blob on a feedback entry
  async gameClientFeedbackUpsertNotes({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await V3API.admin.gameClientFeedbackUpsertNotes(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * Admin actions request log fetches actions requested by admins
  async adminRequests({ commit }) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.adminRequests();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Product boards ====================
  async boardList({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.boardList(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async boardGet({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.boardGet(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async boardCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.boardCreate(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async boardUpdate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.boardUpdate(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async boardDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.boardDelete(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  //* Events =============================================
  // * eventList returns the list of all events matching the params. Paginated and has search param fields
  async eventList({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.eventList(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * eventGet returns the details for a specific event
  async eventGet({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.eventGet(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * eventEdit edits a single user details
  async eventEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.eventEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  async eventDelete({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.eventDelete(payload);
    } catch (error) {
      console.error('error:', error);
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * challenges gets a list of all challenges
  async challenges({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.challenges(payload);

      if (!response?.data) {
        response.data = [];
      }

      // response.data = response.data.sort((a, b) => {
      //   if (a?.name < b?.name) return -1;
      //   if (a?.name > b?.name) return 1;
      //   return 0;
      // });
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * challengeGet returns the details for a specific challenge
  async challengeGet({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.challengeGet(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * challengeEdit edits a single challenge
  async challengeEdit({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.challengeEdit(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * challengeCreate creates a single challenge
  async challengeCreate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.challengeCreate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * ping
  async ping() {
    let response = {};

    try {
      response = await API.admin.ping();
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        reject(response);
      } else {
        resolve(response.data);
      }
    });
  },

  // * apiPartnerList gets a list of all api partners
  async apiPartnerList({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.apiPartnerList(payload);

      if (!response?.data) {
        response.data = [];
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerGet returns the details for a specific api partner
  async apiPartnerGet({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.apiPartnerGet(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerUpdate edits a single api partner
  async apiPartnerUpdate({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.apiPartnerUpdate(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiPartnerSync syncs a single api partner to production
  async apiPartnerSync({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.apiPartnerSync(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response?.status >= 400 || !response?.data) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response?.data);
        resolve(response.data);
      }
    });
  },

  // * quarterlyReportExport exports quarterly sales report
  async quarterlyReportExport({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.quarterlyReportExport(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * apiDocs gets a list of all API docs
  async apiDocs({ commit }) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.apiDocs();

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * schedulerAPIList gets the list of all scheduler APIs
  async schedulerAPIList({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.schedulerAPIList(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * schedulerAPIGet gets the details for a specific scheduler API
  async schedulerAPIGet({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.schedulerAPIGet(payload);

      if (!response?.data) {
        response.data = {};
      }
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * schedulerMessageSend sends a message to a specific scheduler API
  async schedulerMessageSend({ commit }, payload) {
    let response = {};

    commit(GET_ADMIN_DATA);

    try {
      response = await API.admin.schedulerMessageSend(payload);
    } catch (error) {
      response = error;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_ADMIN_DATA_FAILED);
        reject(response);
      } else {
        commit(GET_ADMIN_DATA_SUCCESS, response.data);
        resolve(response.data);
      }
    });
  },

  // * Delete individual image
  // @ Used for ALL image deleting in the drag and drop uploader
  // async deleteImage({ commit }, payload) {
  //   const storageRef = firebase.storage().ref();
  //   commit(GET_ADMIN_DATA);

  //   if (payload.url) {
  //     const fullUrl = payload.url.split('/');
  //     const protocol = fullUrl[0];
  //     const host = fullUrl[2];
  //     let url = `${protocol}//${host}/`;
  //     url = payload.url.replace(url, '');
  //     payload.imagePath = url;

  //     try {
  //       const image = await storageRef.child(payload.imagePath);

  //       image
  //         .delete()
  //         .then(async () => {
  //           console.log('image deleted');
  //           commit(GET_ADMIN_DATA_SUCCESS);
  //         })
  //         .catch((err) => {
  //           console.error(err);
  //           commit(GET_ADMIN_DATA_FAILED);
  //         });
  //     } catch (error) {
  //       console.error('error:', error);
  //       commit(GET_ADMIN_DATA_FAILED);
  //     }
  //   }
  // },
};

// @ MUTATIONS ====================================================================
const mutations = {
  [SET_FROM_DATE](state, payload) {
    state.fromDate = payload;
  },

  [SET_TO_DATE](state, payload) {
    state.toDate = payload;
  },

  [GET_ADMIN_METRICS](state) {
    state.loadingAdminMetrics = true;
  },

  [GET_ADMIN_METRICS_FAILED](state) {
    state.loadingAdminMetrics = false;
  },

  [GET_ADMIN_METRICS_SUCCESS](state, data) {
    state.adminMetrics = data;
    state.loadingAdminMetrics = false;
  },

  //* get active users
  [GET_ACTIVE_USERS](state, payload) {
    // Load individual types separate from the others when specifically called =====
    switch (payload?.type) {
      case 'limitedUsers':
        state.loadingLimitedUsers = true;
        break;
      case 'activeUsers':
        state.loadingActiveUsers = true;
        state.loadingActiveApexUsers = true;
        state.loadingActiveConnectUsers = true;
        break;
      case 'activeApexUsers':
        state.loadingActiveApexUsers = true;
        state.loadingActiveUsers = true;
        state.loadingActiveConnectUsers = true;
        break;
      case 'activeConnectUsers':
        state.loadingActiveConnectUsers = true;
        state.loadingActiveApexUsers = true;
        state.loadingActiveUsers = true;
        break;
      case 'totalUsers':
        state.loading = true;
        break;
      default:
        state.loading = true;
        state.loadingLimitedUsers = true;
        state.loadingActiveUsers = true;
        state.loadingActiveApexUsers = true;
        state.loadingActiveConnectUsers = true;
        break;
    }
  },

  [GET_ACTIVE_USERS_SUCCESS](state, data) {
    // Load individual types separate from the others when specifically called =====
    switch (data?.type) {
      case 'activeUsers':
        state.totalActiveUsers = data.total_active_users;
        state.loadingActiveUsers = false;
        break;
      case 'activeApexUsers':
        state.activeApexUsers = data.apex_active_users;
        state.loadingActiveApexUsers = false;
        break;
      case 'activeConnectUsers':
        state.activeConnectUsers = data.connect_active_users;
        state.loadingActiveConnectUsers = false;
        break;
      case 'totalUsers':
        state.totalUsers = data.total_users;
        state.loading = false;
        break;

      default:
        state.totalUsers = data.total_users;
        state.totalActiveUsers = data.total_active_users;
        state.limitedUsers = data.limited_users;
        state.activeApexUsers = data.apex_active_users;
        state.activeConnectUsers = data.connect_active_users;
        state.loading = false;
        state.loadingActiveUsers = false;
        state.loadingActiveApexUsers = false;
        state.loadingActiveConnectUsers = false;
        state.loadingLimitedUsers = false;
        break;
    }
  },

  [GET_ACTIVE_USERS_FAILED](state) {
    state.loading = false;
    state.loadingActiveUsers = false;
    state.loadingLimitedUsers = false;
  },

  [GET_POPULAR_COURSES](state) {
    state.loadingPopularCourses = true;
  },

  [GET_POPULAR_COURSES_SUCCESS](state, data) {
    state.popularCourses = data;
    state.loadingPopularCourses = false;
  },

  [GET_POPULAR_COURSES_FAILED](state) {
    state.loadingPopularCourses = false;
  },

  [GET_ROUNDS_PER_LICENSE](state) {
    state.loadingRoundsPerLicense = true;
  },

  [GET_ROUNDS_PER_LICENSE_SUCCESS](state, data) {
    state.roundsPerLicense = data;
    state.loadingRoundsPerLicense = false;
  },

  [GET_ROUNDS_PER_LICENSE_FAILED](state) {
    state.loadingRoundsPerLicense = false;
  },

  [GET_LICENSES](state) {
    state.loadingLicenses = true;
  },

  [GET_LICENSES_SUCCESS](state, data) {
    state.licenses = data;
    state.loadingLicenses = false;
  },

  [GET_LICENSES_FAILED](state) {
    state.loadingLicenses = false;
  },

  [GET_USER_LICENSES](state) {
    state.loadingUserLicenses = true;
  },

  [GET_USER_LICENSES_SUCCESS](state, data) {
    state.userLicenses = data ?? [];
    state.loadingUserLicenses = false;
  },

  [GET_USER_LICENSES_FAILED](state) {
    state.loadingUserLicenses = false;
  },

  [DEACTIVATE_LICENSE_PRODUCT](state) {
    state.loadingDeactivate = true;
  },

  [DEACTIVATE_LICENSE_PRODUCT_SUCCESS](state, data) {
    state.loadingDeactivate = false;
  },

  [DEACTIVATE_LICENSE_PRODUCT_FAILED](state) {
    state.loadingDeactivate = false;
  },

  [GET_SHOTS_ROUNDS](state, payload) {
    state.loadingShotsRounds = true;

    switch (payload?.type) {
      case 'guestShots':
        state.loadingGuestShots = true;
        break;
      case 'userShots':
        state.loadingUserShots = true;
        break;
      case 'totalShots':
        state.loadingTotalShots = true;
        break;
      case 'totalRounds':
        state.loadingTotalRounds = true;
        break;
      default:
        state.loadingUserShots = true;
        state.loadingGuestShots = true;
        state.loadingTotalRounds = true;
        state.loadingTotalShots = true;
        break;
    }
  },

  [GET_SHOTS_ROUNDS_SUCCESS](state, data) {
    state.shotDataMetrics = data;
    switch (data?.type) {
      case 'guestShots':
        state.shotsByGuests = data.guest_shots; //* v3 update
        state.loadingShotsRounds = false;
        state.loadingGuestShots = false;
        break;
      case 'userShots':
        state.shotsByUsers = data.user_shots; //* v3 update
        state.loadingShotsRounds = false;
        state.loadingUserShots = false;
        break;
      case 'totalShots':
        state.totalNumberOfShots = data.shots; //* v3 update
        state.loadingShotsRounds = false;
        state.loadingTotalShots = false;
        break;
      case 'totalRounds':
        state.totalNumberOfRounds = data.matches; //* v3 update
        state.loadingShotsRounds = false;
        state.loadingTotalRounds = false;
        break;

      default:
        //* v3 update
        state.totalNumberOfShots = data.shots;
        state.totalNumberOfRounds = data.matches;
        state.shotsByUsers = data.user_shots;
        state.shotsByGuests = data.guest_shots;

        state.loadingShotsRounds = false;
        state.loadingUserShots = false;
        state.loadingGuestShots = false;
        state.loadingTotalRounds = false;
        state.loadingTotalShots = false;
        break;
    }
  },

  [GET_SHOTS_ROUNDS_FAILED](state) {
    state.loadingShotsRounds = false;
    state.loadingTotalShots = false;
    state.loadingTotalRounds = false;
    state.loadingUserShots = false;
    state.loadingGuestShots = false;
  },

  [GET_CLUB_SHOTS](state) {
    state.loadingClubShots = true;
  },

  [GET_CLUB_SHOTS_SUCCESS](state, data) {
    state.clubShots = data;
    state.loadingClubShots = false;
  },

  [GET_CLUB_SHOTS_FAILED](state) {
    state.loadingClubShots = false;
  },

  [GET_TS_SHOTS](state) {
    state.loadingTrackingSystemShots = true;
  },

  [GET_TS_SHOTS_SUCCESS](state, data) {
    state.trackingSystemShots = data;
    state.loadingTrackingSystemShots = false;
  },

  [GET_TS_SHOTS_FAILED](state) {
    state.loadingTrackingSystemShots = false;
  },

  [GET_PRACTICE_AREA_SHOTS](state) {
    state.loadingPracticeAreaShots = true;
  },

  [GET_PRACTICE_AREA_SHOTS_SUCCESS](state, data) {
    state.practiceAreaShots = data;
    state.loadingPracticeAreaShots = false;
  },

  [GET_PRACTICE_AREA_SHOTS_FAILED](state) {
    state.loadingPracticeAreaShots = false;
  },

  [GET_GAME_MODE_METRICS](state) {
    state.loadingGameModeMetrics = true;
  },

  [GET_GAME_MODE_METRICS_SUCCESS](state, data) {
    state.gameModeMetrics = data;
    state.loadingGameModeMetrics = false;
  },

  [GET_GAME_MODE_METRICS_FAILED](state) {
    state.loadingGameModeMetrics = false;
  },

  [RESET_LICENSES](state) {
    state.licenses = [];
  },

  [RESET_USER_LICENSES](state) {
    state.userLicenses = [];
    state.loadingUserLicenses = false;
  },

  [GET_SALES_LOG](state) {
    state.loadingSalesLog = true;
  },

  [GET_DAILY_SALES_LOG_SUCCESS](state, data) {
    state.dailySalesLog = data ?? [];
    state.loadingSalesLog = false;
  },

  [GET_DAILY_SALES_LOG_FAILED](state) {
    state.loadingSalesLog = false;
  },

  [GET_SALES_LOG_SUCCESS](state, data) {
    state.salesLog = data ?? '';
    state.loadingSalesLog = false;
  },

  [GET_SALES_LOG_FAILED](state) {
    state.loadingSalesLog = false;
  },

  [RESET_DAILY_SALES_LOG](state) {
    state.salesLog = null;
  },

  [REDEEM_PRODUCT](state) {
    state.loadingRedeemProduct = true;
  },

  [REDEEM_PRODUCT_SUCCESS](state, data) {
    state.redeemedProduct = data;
    state.loadingRedeemProduct = false;
  },

  [REDEEM_PRODUCT_FAILED](state) {
    state.loadingRedeemProduct = false;
  },

  [LICENSE_ACTIVATION](state) {
    state.loadingLicenseActivation = true;
  },

  [LICENSE_ACTIVATION_FAILED](state, data) {
    state.loadingLicenseActivation = false;
  },

  [LICENSE_ACTIVATION_SUCCESS](state) {
    state.loadingLicenseActivation = false;
  },

  [GET_TRACKING_SYSTEMS](state) {
    state.loadingTrackingSystems = true;
  },

  [GET_TRACKING_SYSTEMS_SUCCESS](state, data) {
    state.trackingSystems = data ?? [];
    state.loadingTrackingSystems = false;
  },

  [GET_TRACKING_SYSTEMS_FAILED](state) {
    state.loadingTrackingSystems = false;
  },

  [GET_PRODUCT_KEYS](state) {
    state.loadingProductKeys = true;
  },

  [GET_PRODUCT_KEYS_SUCCESS](state, data) {
    state.productKeys = data ?? [];
    state.loadingProductKeys = false;
  },

  [GET_PRODUCT_KEYS_FAILED](state) {
    state.loadingProductKeys = false;
  },

  [CREATE_PRODUCT_KEYS](state) {
    state.loadingProductKeys = true;
  },

  [CREATE_PRODUCT_KEYS_SUCCESS](state, data = []) {
    state.newProductKeys = data ?? [];
    state.loadingProductKeys = false;
  },

  [CREATE_PRODUCT_KEYS_FAILED](state) {
    state.loadingProductKeys = false;
  },

  [GET_PRODUCTS](state) {
    state.loadingProducts = true;
  },

  [GET_PRODUCTS_SUCCESS](state, data) {
    state.products = data ?? [];
    state.loadingProducts = false;
  },

  [GET_PRODUCTS_FAILED](state) {
    state.loadingProducts = false;
  },

  [GET_PRODUCT](state) {
    state.loadingProduct = true;
  },

  [GET_PRODUCT_SUCCESS](state, data) {
    state.product = data ?? {};
    state.loadingProduct = false;
  },

  [GET_PRODUCT_FAILED](state) {
    state.loadingProduct = false;
  },

  // @ Marketing Report Data ==================
  [GET_REPORT](state) {
    state.loadingReport = true;
  },

  [GET_REPORT_SUCCESS](state, data = []) {
    state.storeReport = data ?? [];
    state.licenseReport = data?.find((report) => {
      return report.name.includes('New License');
    });
    state.expSubReport = data?.find((report) => {
      return report.name.includes('Subscriptions');
    });
    state.loadingReport = false;
  },

  [GET_REPORT_FAILED](state) {
    state.loadingReport = false;
  },

  [GET_REPORT_FILTER](state) {
    state.loadingReportFilter = true;
  },

  [GET_REPORT_FILTER_SUCCESS](state, data) {
    state.reportFilter = data ?? {};
    state.loadingReportFilter = false;
  },

  [GET_REPORT_FILTER_FAILED](state) {
    state.loadingReportFilter = false;
  },

  [SET_REPORT_FILTER](state) {
    state.loadingReportFilter = true;
  },

  [SET_REPORT_FILTER_SUCCESS](state, data) {
    state.loadingReportFilter = false;
  },

  [SET_REPORT_FILTER_FAILED](state) {
    state.loadingReportFilter = false;
  },

  [GET_LICENSE_REDEEM](state) {
    state.loadingLicenseRedeem = true;
  },

  [GET_LICENSE_REDEEM_SUCCESS](state, data) {
    state.redeemedLicenses = data ?? [];
    state.loadingLicenseRedeem = false;
  },

  [GET_LICENSE_REDEEM_FAILED](state) {
    state.loadingLicenseRedeem = false;
  },

  [GET_EXPIRING_SUB](state) {
    state.loadingExpiringSub = true;
  },

  [GET_EXPIRING_SUB_SUCCESS](state, data) {
    state.expiringSubscriptions = data ?? [];
    state.loadingExpiringSub = false;
  },

  [GET_EXPIRING_SUB_FAILED](state) {
    state.loadingExpiringSub = false;
  },

  [RESET_LICENSE_LOG](state) {
    state.redeemedLicenses = [];
  },

  [GET_TRANSACTIONS](state) {
    state.loadingTransactions = true;
  },

  [GET_TRANSACTIONS_SUCCESS](state, data) {
    state.loadingTransactions = false;
  },

  [GET_TRANSACTIONS_FAILED](state) {
    state.loadingTransactions = false;
  },

  // @ New ADMIN
  [GET_ADMIN_DATA](state) {
    state.loadingAdmin = true;
  },

  [GET_ADMIN_DATA_FAILED](state) {
    state.loadingAdmin = false;
  },

  [GET_ADMIN_DATA_SUCCESS](state, data) {
    state.loadingAdmin = false;
  },

  [GET_ADMIN_GAME_MODES](state) {
    state.loadingAdmin = true;
    state.loadingAdminGameModes = true;
  },

  [GET_ADMIN_GAME_MODES_FAILED](state) {
    state.loadingAdmin = false;
    state.loadingAdminGameModes = false;
  },

  [GET_ADMIN_GAME_MODES_SUCCESS](state, data) {
    state.loadingAdmin = false;
    state.loadingAdminGameModes = false;
  },

  [GET_ADMIN_SIMULATOR_PERMISSIONS](state) {
    state.loadingAdmin = true;
    state.loadingAdminSimulatorPermissions = true;
  },

  [GET_ADMIN_SIMULATOR_PERMISSIONS_FAILED](state) {
    state.loadingAdmin = false;
    state.loadingAdminSimulatorPermissions = false;
  },

  [GET_ADMIN_SIMULATOR_PERMISSIONS_SUCCESS](state, data) {
    state.loadingAdmin = false;
    state.loadingAdminSimulatorPermissions = false;
  },

  [GET_ADMIN_TRACKING_SYSTEMS](state) {
    state.loadingAdmin = true;
    state.loadingAdminTrackingSystems = true;
  },

  [GET_ADMIN_TRACKING_SYSTEMS_FAILED](state) {
    state.loadingAdmin = false;
    state.loadingAdminTrackingSystems = false;
  },

  [GET_ADMIN_TRACKING_SYSTEMS_SUCCESS](state, data) {
    state.loadingAdmin = false;
    state.loadingAdminTrackingSystems = false;
  },

  [COURSE_SYNC](state) {
    state.loadingCourseSync = true;
  },

  [COURSE_SYNC_FAILED](state) {
    state.loadingCourseSync = false;
  },

  [COURSE_SYNC_SUCCESS](state, data) {
    state.loadingCourseSync = false;
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
